import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { inr, fmtDate } from './quoteApi';

const Row = ({ label, sub, amount, strong, accent, testid }) => (
  <div data-testid={testid} className={`flex justify-between gap-3 py-1.5 ${strong ? 'font-semibold' : ''}`}>
    <div className="min-w-0">
      <p className="text-sm text-[#1A1A2E]">{label}</p>
      {sub && <p className="text-[11px] text-[#6B7280]">{sub}</p>}
    </div>
    <span className={`text-sm flex-shrink-0 ${accent ? 'text-green-700' : 'text-[#1A1A2E]'}`}>{amount}</span>
  </div>
);

export const QuoteSummary = ({ calc, loading, error }) => {
  if (error) return <p data-testid="quote-calc-error" className="text-red-600 text-sm">{error}</p>;
  if (!calc) return <p className="text-sm text-[#6B7280]">Pick a villa, dates and guests to see the live price breakdown.</p>;
  return (
    <div data-testid="quote-summary" className={`transition-opacity ${loading ? 'opacity-50' : 'opacity-100'}`}>
      {calc.available === false && (
        <p data-testid="quote-unavailable-warning" className="flex items-start gap-2 text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-xs mb-3">
          <FiAlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" /> These dates look booked for this villa. You can still get a quote — we&apos;ll suggest alternatives.
        </p>
      )}
      {calc.nightly_rows.map((r, i) => (
        <Row key={r.date} testid={`quote-night-row-${i}`} label={`Night ${i + 1} · ${fmtDate(r.date)}`} sub={r.label} amount={inr(r.amount)} />
      ))}
      <Row label={`Extra guests (${calc.extra_guests})`} sub={calc.extra_guests ? `${inr(calc.extra_guest_rate)} × ${calc.extra_guests} × ${calc.nights} nights` : `Up to ${calc.base_capacity} guests included`} amount={inr(calc.extra_total)} />
      {calc.addons.map((a) => <Row key={a.key} label={a.label} sub={a.detail} amount={inr(a.amount)} />)}
      {calc.special_discount > 0 && <Row label="Special discount" sub={calc.special_discount_note} amount={`−${inr(calc.special_discount)}`} accent />}
      <div className="border-t border-dashed border-gray-200 my-1" />
      <Row label="Subtotal" amount={inr(calc.subtotal)} strong testid="quote-subtotal" />
      <Row label="Refundable security deposit" amount={inr(calc.deposit)} />
      <div className="mt-2 bg-[#1A1A2E] text-white rounded-lg px-4 py-3 flex justify-between items-center">
        <span className="text-xs uppercase tracking-wider">Grand Total</span>
        <span data-testid="quote-grand-total" className="text-xl font-bold text-[#F57C20]">{inr(calc.grand_total)}</span>
      </div>
    </div>
  );
};

export default QuoteSummary;
